import { getSubscriptionCharge } from "src/api/subscription";
import { calculateSavedPoint } from "./payUtils";
export function toCheckoutStoreData(data, type) {
    switch(type){
        case "delivery":
        case "separate":
        case "pod":
            const order = data;
            return {
                orderItems: order.items,
                userCoupons: order.userCoupons,
                priceInfo: {
                    originalPrice: order.amount,
                    productDiscount: order.discount || 0,
                    deliveryFee: order.basicDeliveryCharge || 0,
                    remoteAreaFee: order.remoteAreaFee || 0,
                    deliveryDiscount: 0,
                    finalPrice: order.total
                }
            };
        case "pass":
            const pass = data;
            return {
                orderItems: [
                    {
                        id: pass.id.toString(),
                        productTitle: pass.title,
                        price: pass.price,
                        isPointUnusable: pass.isPointUnusable,
                        discountedPrice: pass.price
                    }
                ],
                userCoupons: [],
                priceInfo: {
                    originalPrice: pass.price,
                    productDiscount: pass.originPrice - pass.price,
                    finalPrice: pass.originPrice - pass.price
                }
            };
        case "package":
            const pkg = data;
            return {
                orderItems: [
                    {
                        id: pkg.id.toString(),
                        productTitle: pkg.title,
                        price: pkg.price,
                        isPointUnusable: pkg.isPointUnusable,
                        discountedPrice: pkg.price
                    }
                ],
                userCoupons: [],
                priceInfo: {
                    originalPrice: pkg.price,
                    productDiscount: pkg.originalPrice - pkg.price,
                    finalPrice: pkg.price
                }
            };
        case "upgrade":
            const upgradeOrder = data;
            return {
                orderItems: upgradeOrder.items,
                userCoupons: [],
                priceInfo: {
                    originalPrice: upgradeOrder.total,
                    productDiscount: 0,
                    finalPrice: upgradeOrder.total
                }
            };
        case "ebook":
            const ebook = data;
            return {
                orderItems: ebook.lineItems.map((item)=>({
                        id: item.id,
                        productTitle: item.product.title,
                        price: Number(item.product.price)
                    })),
                userCoupons: [],
                priceInfo: {
                    originalPrice: ebook.lineItems.reduce((acc, item)=>acc + Number(item.product.price), 0),
                    productDiscount: 0,
                    finalPrice: ebook.lineItems.reduce((acc, item)=>acc + Number(item.product.price), 0)
                }
            };
        case "cash":
            var _cash_products_find;
            const cash = data;
            // 현재 캐시 상품은 1개만 내려옴
            const bonusPointValue = cash.products.reduce((acc, item)=>acc + item.bonusPointValue, 0);
            const calcBonusPoint = calculateSavedPoint({
                bonusPointType: (_cash_products_find = cash.products.find((item)=>item.bonusPointType)) === null || _cash_products_find === void 0 ? void 0 : _cash_products_find.bonusPointType,
                bonusPointValue: bonusPointValue || 0,
                price: cash.products.reduce((acc, item)=>acc + item.price, 0)
            });
            return {
                orderItems: cash.products.map((item)=>({
                        id: item.id.toString(),
                        productTitle: item.title,
                        price: item.price
                    })),
                userCoupons: [],
                priceInfo: {
                    originalPrice: cash.products.reduce((acc, item)=>acc + item.price, 0),
                    productDiscount: 0,
                    finalPrice: cash.products.reduce((acc, item)=>acc + item.price, 0),
                    savedPoint: calcBonusPoint
                }
            };
        case "subscription":
            const plan = data;
            // 청구 단가는 첫 구독=판매가 / 재구독=정가. 정가는 '상품 금액'과 할인 행 산출에도 쓴다
            const { currentCharge , discount  } = getSubscriptionCharge(plan);
            return {
                orderItems: [
                    {
                        id: plan.id,
                        productTitle: plan.title,
                        price: currentCharge,
                        // 월구독은 캐시·포인트를 쓸 수 없다 (CheckoutView에서 카드 자체를 숨긴다)
                        isPointUnusable: true,
                        discountedPrice: currentCharge
                    }
                ],
                userCoupons: [],
                priceInfo: {
                    // 체험이 적용되면 이번 회차 청구가 없어 사이드바를 전부 0원으로 표기하고
                    // 할인 행도 숨긴다 (시안 3203:174159). 할인 행은 총 할인이 0보다 클 때만 렌더된다.
                    originalPrice: plan.trialApplied ? 0 : plan.regularPrice,
                    // 월구독은 쿠폰을 쓸 수 없다. 정가와 청구 단가의 차액이 상품 자체 할인이다(재구독은 0).
                    // 쿠폰 할인과 달리 이 값은 스토어가 재계산으로 복원할 수 없어 별도 필드로 넘긴다.
                    baseProductDiscount: plan.trialApplied ? 0 : discount,
                    couponDiscount: 0,
                    productDiscount: plan.trialApplied ? 0 : discount,
                    finalPrice: currentCharge
                }
            };
        default:
            throw new Error("Unknown payment data type");
    }
}
